import apiClient from '../apiClient';
import { handleResponse } from 'src/utils/api-utils';

export const getVapidPublicKey = () => {
  return handleResponse(apiClient.get('/push/public-key'));
};

export const subscribePush = (subscription) => {
  return handleResponse(apiClient.post('/push/subscribe', subscription));
};

export const unsubscribePush = (endpoint) => {
  return handleResponse(apiClient.delete('/push/subscribe', { data: { endpoint } }));
};
